import BaseResource from './index'

export default class DepartmentResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/departments'
}
